<template>
  <div class="relative">
    <label
      class="w-full"
      :class="fieldClass"
    >

      <slot name="label-right" />

      <slot />

      <slot name="label-left" />
    </label>

    <slot name="error">
      <div
        v-if="error"
        class="text-2xs text-danger-50 mb-1"
        :class="errorClass"
      >
        {{ error }}
      </div>
    </slot>
  </div>
</template>

<script>

export default {
  inheritAttrs: false,

  props: {
    fieldClass: {
      type: [String, Array, Object],
      default: () => [
        'relative',
        'inline-block'
      ]
    },
    error: {
      type: String,
      default: ''
    },
    errorClass: {
      type: [Array, Object, String],
      default: ''
    }
  }
}
</script>
